// src/pages/currencies/CreateCurrency.jsx

import React from "react";
import { useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditCurrencies from "../../components/currencies/FormAddEditCurrencies";

const CreateCurrency = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/currencies");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditCurrencies
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateCurrency;
